export default __webpack_public_path__ + "static/elfreda-7bfa770892e47296c7fbfaf10f30b32e.webp";